<template>
  <div v-editable="blok">
    <WSection :margin="true">
      <WMaxWidth>
        <div class="lists">
          <div
            v-for="(group, index) in blok.listGroups"
            :key="`${group.title}-item-${index}`"
            :class="['list', { active: activeList == index }]"
            ref="lists"
          >
            <ul class="grid" v-if="group.largeListItems">
              <li
                v-for="item in group.largeListItems"
                :key="item.id"
                v-observe-visibility="observed"
                v-editable="item"
              >
                <RPerson :blok="item" :highlighted="true"></RPerson>
              </li>
            </ul>
            <ul class="grid" v-if="group.listItems">
              <li
                v-for="item in group.listItems"
                :key="item.id"
                v-observe-visibility="observed"
                v-editable="item"
              >
                <RPerson :blok="item"></RPerson>
              </li>
            </ul>
          </div>
        </div>
      </WMaxWidth>
    </WSection>
  </div>
</template>

<script>
import WSection from "@/components/wrappers/W-Section.vue";
import WMaxWidth from "@/components/wrappers/W-MaxWidth.vue";
import RPerson from "@/components/references/R-Person.vue";

export default {
  name: "LayoutSupporters",
  components: {
    WSection,
    WMaxWidth,
    RPerson,
  },
  metaInfo: {
    title: "Editor",
    meta: [
      {
        name: "robots",
        content: "noindex",
      },
    ],
  },
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
h2 {
  margin-bottom: 40px;
}
.grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  & li {
    padding-bottom: 30px;
    padding-right: 30px;
  }
}
</style>
